import { render, staticRenderFns } from "./CopySequenceModal.vue?vue&type=template&id=47d6b10a&"
import script from "./CopySequenceModal.vue?vue&type=script&lang=js&"
export * from "./CopySequenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports